module.exports = __webpack_public_path__ + "static/og-5b086481dee727149a33e494f9b72bed.png";